import {useState} from "react";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {bookingAPI} from "../common/api/bookingAPI";
import {API_WAITING_LIST, API_WAITING_LIST_EXTRA_APARTMENTS} from "../common/api/apiConstants";

export const useWaitingListExtraApartments = () => {

    const {initialized, authenticated} = useKeycloakFunctions();
    const [extraApartments, setExtraApartments] = useState([]);
    const [extraApartmentsLoading, setExtraApartmentsLoading] = useState(false);
    const [extraApartmentsError, setExtraApartmentsError] = useState(null);

    const getWaitingListExtraApartments = (entryId) => {

        if (initialized && authenticated) {
            setExtraApartmentsLoading(true);
            setExtraApartmentsError(null);

            return bookingAPI.get(API_WAITING_LIST + "/" + entryId + API_WAITING_LIST_EXTRA_APARTMENTS, {redirectOnError: true})
                .then(res => {
                    setExtraApartments(res.data?.apartment_codes);
                    return res.data;
                })
                .catch(err => {
                    setExtraApartmentsError(err);
                    setExtraApartments([]);
                    throw err;
                })
                .finally(() => {
                    setExtraApartmentsLoading(false);
                });
        } else {
            return new Promise(resolve => resolve());
        }
    };

    return {
        getWaitingListExtraApartments,
        extraApartments,
        extraApartmentsLoading,
        extraApartmentsError
    };
};
